import styled from 'styled-components';
import { propStyles } from '../../../../utils/propStyles';

const DocumentsGridTableCaption = styled<any, any>('caption')`
    ${propStyles};
`;

export default DocumentsGridTableCaption;



// WEBPACK FOOTER //
// ./src/Components/Document/DocumentsGrid/StyledComponents/DocumentsGridTableCaption.tsx